<template>
    <div class="paperDetails">
        <div class="search_container">
            <div class="search_left">
                <el-form size="mini" ref="form" class="search_Box" :inline="true" :model="PaperData">
                    <el-form-item label="试卷名称">
                        <el-input v-model="PaperData.content" @change="getPaperList(1)" clearable placeholder="请输入试卷名称"></el-input>
                    </el-form-item>
                    <el-form-item label="科目分类" class="mySelect">
                        <el-select v-model="PaperData.subjectId" @change="getPaperList(1)" clearable placeholder="全部">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary" size="mini" @click="getPaperList(1)">查询</el-button>
            </div>
            <div class="search_right">
                <div class="backBtn" @click="backBtn"><img class="backIcon" src="../../../assets/image/home/back.png" alt="">返回</div>
            </div>
        </div>
        <div class="comPractice_container">
            <div class="title_box">
                <div class="left_title">
                    <span class="planName">{{planInfoData.schemeName}}</span> | <span class="subjectName">{{planInfoData.professionName}}</span> | <span class="grade"> {{planInfoData.raceName}}</span>
                </div>
                <div class="btn_box">
                    <el-button type="primary" size="mini" @click="AddTestPaperBtn">添加试卷</el-button>
                    <el-button type="primary" size="mini" @click="removeTestPaperBtn('batch')">批量移除试卷</el-button>
                </div>
            </div>
            <basic-table v-loading="loading" :isCheckbox='true' ref="paperDetailsBasicTable" @operation="operation" :tableHeader="examPaperDisplayList" :tableData="tableData">
                <template slot-scope="data">
                    <el-button size="mini" type="text" @click="removeTestPaperBtn('single', data.row)">移除</el-button>
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="limitSize" :page.sync="pageNo" @currentChange="currentChange"></pagination>
        </div>
        <!-- 添加试卷 -->
        <el-dialog title="选择试卷" :visible.sync="addPaperTestVisible" class="addPaperTestDialog" width="800px" :before-close="AddTesthandleClose">
            <div class="dialog_container">
                <div class="searchBox">
                    <div class="searchBox_left">
                        <div class="margin_box">试卷名称</div>
                        <el-input size="mini" style="width: 200px;" @change="getpaperTestFun(1)" placeholder="请输入试卷名称" v-model="PaperTestForm.content"></el-input>
                    </div>
                    <div class="searchBox_right">
                        <div class="margin_box">科目分类</div>
                        <el-select v-model="PaperTestForm.subjectId" @change="getpaperTestFun(1)" size="mini" clearable placeholder="请选择科目分类">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>

                    <el-button type="primary" @click="getpaperTestFun(1)" size="mini">查询</el-button>

                </div>
                <div class="basicTable">
                    <basic-table v-loading="loadingCopy" :isSelectPaper="true" TableHeight="100%" :isCheckbox='true' ref="paperTestTable" :isOperate="false" @operation="paperTestOperation" :tableHeader="examPaperDisplayList" :tableData="paperTestData"></basic-table>
                </div>
                <pagination :total="totalCopy" :limit.sync="pagesize" :page.sync="current" @currentChange="currentChangePaperTest"></pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancelBtn">取 消</el-button>
                <el-button size="mini" type="primary" @click="paperTestSureBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import { examPaperDisplayList } from '../globalData'
import fetch from '@/api/fetch'
export default {
    name: 'paperDetails',

    data() {
        return {
            PaperData: {
                content: '',
                subjectId: '',
                schemeId: ''
            },
            pageNo: 1,
            limitSize: 10,
            examPaperDisplayList: examPaperDisplayList,
            tableData: [],
            paperTestData: [],
            subjectList: [],
            total: 0,
            totalCopy: 0,
            loading: false,
            loadingCopy: false,
            addPaperTestVisible: false,
            PaperTestForm: {
                content: '',
                subjectId: '',
                id: ''
            },
            current: 1,
            pagesize: 10,

            selectPaperTestData: [],
            removeTestPaperData: [],
            currentTimeout: null,
        };
    },
    props: {
        planInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        planInfoData() {
            return this.planInfo
        }
    },

    mounted() {
        this.PaperData.schemeId = this.planInfoData.id
        this.PaperTestForm.id = this.planInfoData.id

        this.getSubjectList()
        this.getPaperList()
    },

    methods: {
        cancelBtn() {
            this.addPaperTestVisible = false
            this.PaperTestForm.content = ''
            this.PaperTestForm.subjectId = ''
            this.selectPaperTestData = []
            this.$refs.paperTestTable.$refs.basicTable.$parent.getClearSelect()
        },
        removeTestPaperBtn(type, rowData) {
            if (type == 'batch') {
                if (this.removeTestPaperData.length <= 0) {
                    this.$message.error('请批量选择删除的数据')
                } else {
                    this.$confirm('此操作将会删除该试卷, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.removePaperTestFun(1)
                        this.removeTestPaperData = []
                        this.$refs.paperDetailsBasicTable.$refs.basicTable.$parent.getClearSelect()
                    }).catch(() => {
                        this.$message.info('已取消')
                    })
                }
            } else {
                this.$confirm('此操作将会删除该试卷, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removePaperTestFun(0, rowData.id)
                }).catch(() => {
                    this.$message.info('已取消')
                })
            }
        },
        removePaperTestFun(type, rowDataID) {
            fetch.batchDeletePaper({
                idList: type ? this.removeTestPaperData : [rowDataID]
            }).then(res => {
                if (res.code == '0') {
                    this.getPaperList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        currentChange(val) {
            this.limitSize = val.limit
            this.pageNo = val.page
            this.getPaperList(this.pageNo)
        },
        getPaperList(page) {
            this.loading = true
            fetch.pageListPaper({ ...this.PaperData, pageNo: page || this.pageNo, limitSize: this.limitSize }).then(res => {
                if (res.code == '0') {
                    this.loading = false
                    this.tableData = res.data.records
                    this.total = res.data.total
                    this.pageNo = res.data.current
                    this.limitSize = res.data.size
                } else {
                    this.loading = false
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        AddTesthandleClose() {
            this.PaperTestForm.content = ''
            this.PaperTestForm.subjectId = ''
            this.addPaperTestVisible = false
            this.selectPaperTestData = []
            this.$refs.paperTestTable.$refs.basicTable.$parent.getClearSelect()

        },
        async getpaperTestFun(page) { // 添加试卷的列表
            this.loadingCopy = true
            const res = await fetch.getlistPagePaper({ ...this.PaperTestForm, pageNo: page || this.current, limitSize: this.pagesize })
            if (res.code == '0') {
                // console.log(res)
                this.loadingCopy = false
                this.paperTestData = res.data.records
                this.totalCopy = res.data.total
                this.current = res.data.current
                this.pagesize = res.data.size
            } else {
                this.loadingCopy = false
                this.$message.error(res.msg)
            }
        },
        AddTestPaperBtn() {
            this.addPaperTestVisible = true
            this.getpaperTestFun()
        },
        operation(val, rowData) {
            if (val == 'selectChange') {

                this.removeTestPaperData = rowData.map(item => {
                    return item.id
                })
            }
        },
        currentChangePaperTest(val) {
            console.log(val)
            this.pagesize = val.limit
            this.current = val.page
            this.currentTimeout = setTimeout(() => {
                this.getpaperTestFun(this.current)
            }, 30)
        },
        paperTestOperation(val, rowData) {
            // addBatchPaper
            if (val == 'selectChange') {
                this.selectPaperTestData = rowData.map(item => {
                    return { ...item, professionId: this.planInfoData.professionId, schemeId: this.planInfoData.id }
                })
            }
        },
        paperTestSureBtn() {
            if (this.selectPaperTestData.length <= 0) {
                this.$message.error('请选择试卷')
            } else {
                fetch.addBatchPaper({ paperList: this.selectPaperTestData }).then(res => {
                    if (res.code == '0') {
                        // console.log(res)
                        this.PaperTestForm.content = ''
                        this.PaperTestForm.subjectId = ''
                        this.addPaperTestVisible = false
                        this.selectPaperTestData = []
                        this.$refs.paperTestTable.$refs.basicTable.$parent.getClearSelect()
                        this.getPaperList()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        getSubjectList() { // 科目下拉
            fetch.getSubjectList({ id: this.planInfoData.id }).then(res => {
                if (res.code == '0') {
                    console.log(res)
                    this.subjectList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        backBtn() {
            this.$emit('changeActive', 0)
        }
    },
    beforeDestroy() {
        clearTimeout(this.currentTimeout)
        this.currentTimeout = null
    },
    components: {
        // BaseSearch: () => import('../../components/baseSearch.vue'),
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue')
    }
};
</script>

<style lang="scss" scoped>
.paperDetails {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 0 20px;
        box-sizing: border-box;

        .search_left {
            width: 75%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .search_Box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }
        .search_right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 25%;
            height: 100%;
        }
        .backBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
        .backIcon {
            width: 40px;
            height: 30px;
        }
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .title_box {
        display: flex;
        height: 60px;
        justify-content: space-between;
        align-items: center;
        .left_title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 80%;
            height: 100%;
            .planName {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 10px;
                height: 30px;
                box-sizing: border-box;
                font-size: 14px;
                color: #606266;
            }
            .subjectName {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
                box-sizing: border-box;
                height: 30px;
                font-size: 14px;
                color: #606266;
            }
            .grade {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
                height: 30px;
                box-sizing: border-box;
                font-size: 14px;
                color: #606266;
            }
        }
        .btn_box {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            width: 20%;
            height: 100%;
        }
    }
    /deep/.searchBox {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .searchBox_left {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 20px;
        }
        .searchBox_right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-right: 20px;
        }
        .margin_box {
            margin-right: 5px;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .addPaperTestDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }

    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>